module.exports = __webpack_public_path__ + "static/img/6_5_xuebi.9b0ef2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6_5_xuebi.png
// module id = J5gU
// module chunks = 1